import axiosConfig from "../../utils/axiosConfig";

const BASE_PATH = "profiles/client_profile_info";

export const userProfileApi = {
  getProfile() {
    return axiosConfig.get(BASE_PATH);
  },

  update(params) {
    return axiosConfig.put(BASE_PATH, params);
  }
};
